import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import UnClickableScreenReader from '../../../components/ScreenReader/UnClickableScreenReader';

import { connect } from '../../../reducers/index';
import { url } from '../../../constants/routes';
import './styles.css';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import SingleSelectQuestions from '../../../components/Questions/SingleSelectQuestions';
// import IdentifyGraphic02 from '../img/male-with-bubbles-graphic.svg';
// import IcebergGraphic from './img/iceberg-graphic.svg';
// import GaugeGraphic from './img/emotion-gauge-graphic.svg';

const IdentifyPage = props => {
  const questions = {
    //title: 'Question 2: Indicators',
    type: 'multiple',
    text: (
      <Fragment>
        <UnClickableScreenReader
          text={`Now that we’ve reviewed a list of some common indicators in different scenarios, let’s explore your ability to identify a few of these behaviours, thoughts, and feelings in sample U of T situations. Which of these situations might be your reason for wanting to check in with someone? Select all that apply.`}
        />
          Now that we’ve reviewed a list of common indicators, let’s explore your ability to identify behaviours, thoughts, and feelings in different scenarios.
        <br />
        <br />
        <strong>
          Which of these situations might be your reason for wanting to check in with someone?
        </strong>
        <br />
        (select all that apply)
      </Fragment>
    ),
    result: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
    feedback: {
      correct:
        'Correct! Although all of these may simply be examples of the busy and complex lives that students lead, they could also be indicators that a person may be experiencing a bigger challenge. The students in many of these examples may not need any support but each of these situations provides an opportunity to check in.',
      incorrect:
        'You’re close, but it’s potentially ALL of the above. Although all of these may simply be examples of the busy and complex lives that students lead, they could also be indicators that a person may be experiencing a bigger challenge. The students in many of these examples may not need any support but each of these situations provides an opportunity to check in.',
      all:
        'An offer of help early on can often help prevent situations from becoming more complex. By asking about someone’s thoughts, feelings or behaviours, you’re fostering a culture of care and establishing yourself as someone they could reach out to for support in the future.'
    }
  };
  const options = [
    {
      prefix: 'A',
      result: 'correct',
      optionText:
        'Lately, you’ve noticed that Sameer has been showing up to class looking disheveled.'
    },
    {
      prefix: 'B',
      result: 'correct',
      optionText:
        'Karina keeps requesting to reschedule your project meetings at the last minute. She’s offered a plausible reason each time.'
    },
    {
      prefix: 'C',
      result: 'correct',
      optionText:
        'Baseer complains about his awful roommates and how they frequently exclude him from house activities.'
    },
    {
      prefix: 'D',
      result: 'correct',
      optionText:
        'Mik volunteers to help plan the department’s Meet the Prof night but hasn’t responded to any of the group’s emails.'
    },
    {
      prefix: 'E',
      result: 'correct',
      optionText:
        'It’s midterm season. Kenji has been struggling to keep his eyes open in class.'
    },
    {
      prefix: 'F',
      result: 'correct',
      optionText:
        ' After finding out her paper was rejected by yet another journal, Priya talks about how pointless it is to carry on.'
    },
    {
      prefix: 'G',
      result: 'correct',
      optionText:
        'Felicia tells you about how much she is missing her family and her dogs back in Halifax.'
    },
    {
      prefix: 'H',
      result: 'correct',
      optionText:
        'Jordan hasn’t turned in their last three assignments because they’re only worth 1% each.'
    }
  ];

  return (
    <EducationModuleLayout
      progressStage={6}
      childTitle="Identify"
      progressType="identify"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader
                text={`Recognizing Concerning Behaviours, Thoughts & Feelings`}
              />
              <h2 className="txt-purple no-bold no-margin">
                Identifying in Action
              </h2>
            </Col>
          </Row>
        </div>
      </section>
      <SingleSelectQuestions
        questions={questions}
        options={options}
        questionType="identify"
        nextRoute={url.ASSIST}
        previousRoute={() => props.history.goBack()}
      />
    </EducationModuleLayout>
  );
};

IdentifyPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const IdentifyF = IdentifyPage;
export default connect.role(IdentifyF);



// WEBPACK FOOTER //
// ./src/containers/Identify/IdentifyF/index.jsx